import React, { useEffect, useContext, useRef } from 'react';
import styled, { ThemeContext, css } from 'styled-components';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import breakpoint from 'styled-components-breakpoint';
import { withTranslation } from "react-i18next";
import { blues, greys, reds, rgba } from '../../core/colors';
import MobileMenuButton from '../../component/MobileMenuButton';

const ToTopDetector = styled.div``;

const HoverMenu = styled.nav`
  position: absolute;
  top: calc(100% - 20px);
  transform: ${(props) => ((props.theme.langCode !== 'en') ? 'translateX(0)' : 'translateX(-45px)')};
  box-shadow: 0px 1px 4px 0px ${rgba(greys[10].main, 0.15)};
  display: none;
  ul {
    list-style: none;
    padding: 0px;
    margin: 0px;
    li {
      a {
        padding: 10px 24px;
        font-size: 1rem;
        color: ${blues[1].main};
        white-space: nowrap;
        background-color: ${greys[2].main};
        &:hover, &.active {
          color: ${greys[1].main};
          background-color: ${reds[2].main};
        }
      }
    }
  }
`;

const StyledLi = styled.li`
  height: inherit;
  margin-left: 24px;
  a {
    color: ${greys[3].main};
    display: flex;
    height: inherit;
    align-items: center;
    font-size: 1.0625rem;
    font-weight: 600;
    line-height: 23px;
    &.active {
      color: ${blues[1].main};
    }
    &:hover {
      text-decoration: underline;
      ${HoverMenu} {
        display: block;
      }
    }
  }
`;
const StyledUl = styled.ul`
  display: flex;
  list-style: none;
  padding: 0px;
  margin: 0px;
  height: inherit;
  position: relative;
`;
const MenuNav = styled.nav`
  height: inherit;
  display: none;
  position: relative;
  z-index: 2;
  ${breakpoint('lg')`
    display: block;
  `}
`;

const SiteLogo = styled.div`
  background-size: 100% 100%;
  /* background-color: ${greys[3].main}; */
  background-image: url('data:image/svg+xml;base64,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');
  width: 204px;
  height: 45px;
  z-index: 3;
  position: relative;
  vertical-align: middle;
  background-position: center center;
  background-repeat: no-repeat;
  a {
    display: block;
    height: inherit;
    width: inherit;
  }
  ${breakpoint('lg')`
    width: 254px;
    height: 56px;
  `}
`;

const LangMenuSwitch = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  a {
    margin-right: 20px;
    &:last-child {
      margin-right: 0;
      margin-left: 20px;
    }
  }
`;

const StyledMobileLi = styled(StyledLi)`
  margin: 0;
  padding: 13px 0 12px;
  display: flex;
  justify-content: center;
  border-bottom: 2px solid ${greys[2].main};
`;
const StyledMobileUl = styled(StyledUl)`
  flex-flow: column;
`;
const MobileMenuNav = styled.nav``;

const MobileMenuContainer = styled.div`
  max-height: 0;
  overflow: hidden;
  height: 100vh;
  width: 100%;
  position: fixed;
  top: 84px;
  left: 0;
  z-index: 2;
  transition: max-height 0.2s ease-in-out;
  background-color: ${greys[1].main};
  padding: 0 20px;
  &.active {
    max-height: calc(100vh - 84px);
  }
`;

const ALinkCSS = css`
  color: ${greys[1].main};
  font-size: 17px;
  line-height: 23px;
  font-weight: 600;
  &:hover {
    text-decoration: underline;
  }
`;
const LangSwitcher = styled.div`
  a {
    ${ALinkCSS};
    margin-left: 24px;
  }
`;
const Tel = styled.a`
  ${ALinkCSS};
  &:nth-child(n+2) {
    margin-left: 24px;
  }
`;
const HeaderSwitcher = styled.div`
  height: 40px;
  position: relative;
  z-index: 1;
  padding: 0 35px;
  display: none;
  background-color: ${rgba(blues[1].main, 0.9)};
  align-items: center;
  justify-content: flex-end;
  ${breakpoint('lg')`
    display: flex;
  `}
`;

const MenuContainer = styled.div`
  display: flex;
  height: inherit;
  align-items: center;
  justify-content: space-between;
`;

const MenuWrapper = styled.div`
  padding: 0 20px;
  height: inherit;
  width: inherit;
  ${breakpoint('lg')`
    padding: 0 35px;
  `}
`;

const StyledHeader = styled.header`
  height: 84px;
  width: 100%;
  background-color: ${greys[1].main};
  border-bottom: 4px solid ${reds[2].main};
  position: sticky;
  top: 0;
  z-index: 9999;
`;

const Header = ({ t, i18n, match, location, ...props }) => {
  const { isLgUp } = useContext(ThemeContext);
  const matchLink = "/" + match.url.split('/')[1];
  const mobileMenuRef = useRef();
  const mobileMenuButtonRef = useRef();

  const preventDefault = (e) => {
    e.preventDefault();
  };

  const mobileOpenHandle = () => {
    if (mobileMenuButtonRef && mobileMenuButtonRef.current) mobileMenuButtonRef.current.classList.toggle('active');
    if (mobileMenuRef && mobileMenuRef.current) mobileMenuRef.current.classList.toggle('active');
  };

  useEffect(() => {
    if (mobileMenuButtonRef && mobileMenuButtonRef.current && mobileMenuButtonRef.current.classList.contains('active')) {
      if (isLgUp) {
        mobileOpenHandle();
      }
    }
  }, [isLgUp]);

  return (
    <>
      <ToTopDetector id="top" />
      <StyledHeader>
        <MenuWrapper>
          <MenuContainer>
            <SiteLogo>
              <NavLink to={`${matchLink}/`} />
            </SiteLogo>
            <MenuNav>
              <StyledUl>
              {t('menu', { returnObjects: true }).map((value, index) => (
                <StyledLi key={index}>
                  {value.sub ? (
                    <NavLink activeClassName='active' to={`${matchLink}/${value.key}`} onClick={(e) => preventDefault(e)}>
                      {value.name}
                      <HoverMenu>
                        <ul>
                        {value.sub.map((subValue, subIndex) => (
                          <li key={subIndex}>
                            <NavLink exact activeClassName='active' to={`${matchLink}/${value.key}/${subValue.key}`}>{subValue.name}</NavLink>
                          </li>
                        ))}
                        </ul>
                      </HoverMenu>
                    </NavLink>
                  ) : (
                    <NavLink exact activeClassName='active' to={`${matchLink}/${value.key}`}>{value.name}</NavLink>
                  )}
                </StyledLi>
              ))}
              </StyledUl>
            </MenuNav>
            <MobileMenuButton
              onClickFn={mobileOpenHandle}
              thisRef={mobileMenuButtonRef}
            />
          </MenuContainer>
          <MobileMenuContainer ref={mobileMenuRef}>
            <MobileMenuNav>
              <StyledMobileUl>
              {t('menu', { returnObjects: true }).map((value, index) => (
                <StyledMobileLi key={index}>
                  <NavLink exact activeClassName='active' to={`${matchLink}/${value.key}`} onClick={() => mobileOpenHandle()}>{value.name}</NavLink>
                </StyledMobileLi>
              ))}
              <StyledMobileLi>
                <LangMenuSwitch>
                  <a href={`${location.pathname.replace(match.url, "/tc")}`}>{t('tc')}</a>
                  {` / `}
                  <a href={`${location.pathname.replace(match.url, "/en")}`}>{t('en')}</a>
                </LangMenuSwitch>
              </StyledMobileLi>
              </StyledMobileUl>
            </MobileMenuNav>
          </MobileMenuContainer>
        </MenuWrapper>
        <HeaderSwitcher>
          <Tel href={`tel:${t('tel')}`}>{t('telName')}</Tel>
          <Tel as="span">{t('faxName')}</Tel>
          <Tel href={`mailto:${t('email')}`}>{t('emailName')}{t('email')}</Tel>
          <LangSwitcher>
            <a href={`${location.pathname.replace(match.url, "/tc")}`}>{t('tc')}</a>
            <a href={`${location.pathname.replace(match.url, "/en")}`}>{t('en')}</a>
          </LangSwitcher>
        </HeaderSwitcher>
      </StyledHeader>
    </>
  );
};

Header.propTypes = {
  match: PropTypes.object,
  location: PropTypes.object,
};

Header.defaultProps = {
  match: {},
  location: {},
};

export default withTranslation('header')(Header);
